<template>
  <div class="w-full flex items-center justify-center" v-if="showData.length">
    <UINewTooltipWithText placement="bottom" v-if="showData.includes('rkn')">
      <template #text>
        <p>Канал зарегистрирован в РКН</p>
      </template>
      <div
        class="w-[18px] rounded-full flex items-center justify-center cursor-pointer z-2 ring-2 ring-white"
      >
        <img src="~/assets/svg/RKN.svg" class="w-[18px]" />
      </div>
    </UINewTooltipWithText>
    <UINewTooltipWithText placement="bottom" v-if="showData.includes('cheat')">
      <template #text>
        <p>Канал заподозрен в накрутке</p>
      </template>
      <div
        class="w-[16px] rounded-full flex items-center justify-center cursor-pointer z-3 ring-2 ring-white"
        :class="{ '-ml-1': data.length > 1 }"
      >
        <img src="~/assets/svg/Warning.svg" class="w-[16px]" />
      </div>
    </UINewTooltipWithText>
  </div>
</template>

<script lang="ts" setup>
  const props = defineProps<{
    data: any;
  }>();
  const showData = ref<string[]>([]);

  const dataWork = () => {
    // CHEATING
    if (props.data.cheating) {
      showData.value.push("cheat");
    }
    if (props.data?.rknRegistration?.isRegistered) {
      showData.value.push("rkn");
    }
  };
  watch(
    () => props.data,
    () => {
      showData.value = [];
      dataWork();
    },
    { deep: true }
  );
  onMounted(() => {
    showData.value = [];
    dataWork();
  });
</script>

<style></style>
